const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/types.ts';
import React from 'react';
import { MessageDescriptor } from 'react-intl';
import { RequestStatus } from '../../utils/redux4Requests';
import { KeyValuePair } from '../../defs/generalDefs';

export type SaveStatus = 'DISABLED' | 'SAVED' | '';

export interface CIS4mConfig {
    id: string;
    dataObject: any;
    renderForm: () => React.ReactElement<any, any>;
    callback: (formId: string, dataObject: any) => Generator<any, boolean>;
}

export interface CIS4mData extends CIS4mConfig {
    initialDataObject: any;
    lastChanged: string | undefined;
    lastSaved: string | undefined;
    requestStatus: RequestStatus;
}

export type CIS4msMap = KeyValuePair<CIS4mData>;

export interface CIS4mTreeComponentProps {
    hidden?: boolean;
    readonly?: boolean;
    disabled?: boolean;
}

export interface CIS4mValueComponentProps extends CIS4mTreeComponentProps {
    path: string;
    initialValue?: any;
}

export interface CIS4mStoreData extends Omit<CIS4mData, 'renderForm' | 'callback'> {
    renderFormFunctionId: string;
    callbackFunctionId: string;
}

export type OptionEntryValue = string | OptionObject;

export interface OptionEntry {
    label: string | MessageDescriptor;
    value: OptionEntryValue;
}

export interface RadioButtonOptionEntry {
    label: string;
    value: string;
    img?: string;
}

export interface RadioButtonGroupSubheader {
    subheader: string | MessageDescriptor;
}

export interface OptionObject {
    [key: string]: string;
}

export enum JaNeinOptions {
    Ja = 'Ja',
    Nein = 'Nein',
}
